import { configureStore } from '@reduxjs/toolkit';
import liveNumSlice from './liveNumSlice';
import sidebarToggleSlice from './sidebarToggleSlice';
export const store = configureStore({
    reducer: {
        liveNum: liveNumSlice,
        sideBarToggle: sidebarToggleSlice,
    },
});